import * as Firebase from "./Firebase";
export default Firebase;
